import { useEffect } from "react";
const MobileRedirect = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_NODE_API}/mobile`;
  }, []);

  return <p>Redirecting to NimbleBash app...</p>;
};

export default MobileRedirect;
